import { MAX_GEMINI_TEXT_CHARACTERS, MAX_CACHED_BLOCK_WORDS, MAX_CACHED_BLOCK_SOURCES } from './audio-limits.ts';
export type BlockSettings = { maxCharacters: number; maxWords: number; maxSources: number };
/** Invalid/unavailable settings retain the established planner; hard safety bounds never move. */
export function blockSettings(value: unknown): BlockSettings {
  const s = (value && typeof value === 'object' ? value : {}) as Record<string, unknown>;
  const integer = (key: string, min: number, max: number) => Number.isSafeInteger(s[key]) && Number(s[key]) >= min && Number(s[key]) <= max ? Number(s[key]) : max;
  return { maxCharacters: integer('block_max_characters', 200, MAX_GEMINI_TEXT_CHARACTERS),
    maxWords: integer('block_max_words', 20, MAX_CACHED_BLOCK_WORDS),
    maxSources: integer('block_max_sources', 1, MAX_CACHED_BLOCK_SOURCES) };
}
